const Tables = {
    Companies : "Companies",
    Tenants : "Tenants",
    NativeAppConf: "NativeAppConf",
    Users: "AspNetUsers",
    Meetings: "Meetings",
    Nodes: "Nodes",
    Boards: "Boards",
    BoardNodes: "BoardNodes",
};

export default Tables;